/**
 * Appends the catalog's own column-based availability model
 * (`buildRichAvailabilityColumns`) to the merged table (offer-unified-table,
 * CU-86cbc3r8b) — the proposal's Decision is to reuse this exact model "with
 * offer-supplied popover content" rather than inventing a second rendering
 * engine for availability. No trailing "load more" column here (unlike the
 * catalog's genuinely unbounded inventory): the offer table always renders
 * the offer's own full od/do range (CU-86cbejhgd).
 *
 * `buildRichAvailabilityColumns` is generic over the row type, constrained to
 * `{ id }` — every renderer/classifier it builds reads only `item.id`, never
 * any other row-specific field, so `OfferUnitItem` is passed as the explicit
 * type argument instead of casting the catalog's `MediaUnitListItem`-shaped
 * result past a row-type mismatch.
 */
import type { ColumnDef } from '@ooh/ui/components/data-table';
import {
  buildRichAvailabilityColumns,
  type BuildRichAvailabilityColumnsOptions,
} from '@ooh/screens';
import type { OfferUnitItem } from '../units-tab-columns';

export function buildOfferAvailabilityColumns(
  options: BuildRichAvailabilityColumnsOptions,
): ColumnDef<OfferUnitItem>[] {
  return buildRichAvailabilityColumns<OfferUnitItem>(options);
}
